import React, { useState, useMemo, forwardRef, useId } from 'react';
import Select from 'react-select';
import DatePicker, { CalendarContainer } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { get } from 'lodash';
import { MultiSelect } from 'react-multi-select-component';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useTranslation } from 'react-i18next';
import HtmlEditorModal from './HtmlEditorModal';
import { checkIsNumber, customStyles } from '../../../../Components/helper';

export function RenderHtmlComponent({
  keyType,
  options,
  value,
  onChange,
  pIndex,
  index,
  disableCondition,
  status,
  characterLimit,
  labelColours,
  datePickerTime,
  inde,
  subType,
  statusColoursOptions,
  columnType,
}) {
  const [state, setState] = useState({
    activeHtmlEditor: false,
  });
  const { t } = useTranslation('common');

  const { activeHtmlEditor } = state;

  // Helper function to check if a value is a valid date
  const isValidDate = (dateValue) => {
    if (!dateValue || dateValue === '' || dateValue === 'Multiple') return false;
    const date = new Date(dateValue);
    return date instanceof Date && !isNaN(date.getTime());
  };

  // Get safe date value for DatePicker
  const getSafeDateValue = (dateValue) => {
    return isValidDate(dateValue) ? new Date(dateValue) : null;
  };

  const toggle = () => {
    setState((prev) => ({ ...prev, activeHtmlEditor: false }));
  };

  let activeStatus;
  if (statusColoursOptions) {
    activeStatus = statusColoursOptions?.find((ele) => {
      if (ele.setDefault === true) {
        return true;
      }
      if (value) {
        return ele._id === value?._id;
      }
      if (status?._id) {
        return ele._id === status?._id;
      }
      return ele.colourHexCode === status?.colourHexCode;
    });
  }

  const selectStyle = {
    ...customStyles,
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '25px',
      border: '1px solid #848484',
      marginTop: '0',
      backgroundColor: `${activeStatus?.colourHexCode} !important`,
      color: '#FFF',
      padding: '0 5px',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.7 : 1;
      return { ...provided, opacity, color: '#000' };
    },
    option: (styles, { data, isSelected }) => {
      const foundStatus = statusColoursOptions?.find((status) => status.colourName === data.colourName);
      return {
        ...styles,
        color: isSelected ? '#000' : `${foundStatus?.colourHexCode} !important`,
        backgroundColor: isSelected ? `${foundStatus?.colourHexCode} !important` : 'white',
      };
    },
    valueContainer: (provided) => ({
      ...provided,
      alignItems: 'center',
    }),
  };

  const multipleDropdonwOptions = useMemo(() => {
    if (keyType !== 'Multi_select_Dropdown') return [];

    return (options ?? [])
      .filter((opt) => opt?.name?.trim() !== '')
      .map((opt) => ({
        label: opt?.name,
        value: opt?.name,
        isDefault: opt?.isDefault,
      }));
  }, [keyType, options]);

  function createMarkup(value) {
    return {
      __html: value,
    };
  }
  function MyContainer({ className, children }) {
    return (
      <CalendarContainer className={className}>
        <div style={{ position: 'relative' }}>{children}</div>
      </CalendarContainer>
    );
  }

  const renderComponentByType = () => {
    switch (keyType) {
      case 'Dropdown': {
        const selectedValue = columnType === 'manual' && !value ? options?.find((opt) => opt.isDefault) : value;
        const validOptions = (options ?? []).filter((opt) => opt?.name?.trim() !== '');

        return (
          <div className="w-100 m-w-150">
            <Select
              name="Location"
              options={validOptions}
              styles={customStyles}
              placeholder={t('RANGE_PLANS.PRODUCT_LIST.RENDER_HTML_COMPONENET.HTML_EDITOR.CUSTOM_SECTION')}
              getOptionLabel={(option) => `${option.name}`}
              getOptionValue={(option) => `${option.name}`}
              value={selectedValue}
              onChange={(selected) => onChange(selected)}
              menuPosition="fixed"
              menuShouldBlockScroll
              menuShouldScrollIntoView
              isDisabled={disableCondition}
              isClearable
            />
          </div>
        );
      }

      case 'Checkbox':
        return (
          <div className="checkbox-label margin-auto w-150px">
            {options?.map((opt, ind) => {
              const checkboxId = `Checkbox_${fieldId}_${ind}`;

              return (
                <>
                  <input
                    type="checkbox"
                    onChange={(e) => onChange({ [ind]: e.target.checked })}
                    name={checkboxId}
                    id={checkboxId}
                    checked={get(value, `[${ind}]`, false)}
                    disabled={disableCondition}
                  />
                  <label htmlFor={checkboxId} className="chklabel">
                    <span>{opt?.name}</span>
                  </label>
                </>
              );
            })}
          </div>
        );

      case 'Radio_button':
        return (
          <div className="d-flex align-items-center flex-wrap w-150px">
            {options?.map((opt, i) => {
              const radioId = `radioUniqIds_${fieldId}_${i}`;
              return (
                <div className="custom-radio mr-2 my-1" key={i}>
                  <input
                    type="radio"
                    id={radioId}
                    value={opt?.name}
                    onChange={(e) => {
                      onChange(e.target.value);
                    }}
                    checked={value === opt?.name}
                    disabled={disableCondition}
                  />
                  <label className="mb-0" htmlFor={radioId}>
                    {opt?.name}
                    &nbsp;
                  </label>
                </div>
              );
            })}
          </div>
        );

      case 'Date_picker':
        return (
          <div className="icon-container w-100 m-w-180">
            <div className="valueProp">
              <div className="input-button-container custom-calender">
                <DatePicker
                  dateFormat="dd-MMM-yyyy"
                  popperPlacement="bottom-end"
                  name="selectedDate"
                  onChange={(date) => onChange(date)}
                  timeInputLabel=""
                  showTimeInput={datePickerTime}
                  closeOnScroll
                  customInput={<ExampleCustomInput />}
                  disabled={disableCondition}
                  calendarContainer={MyContainer}
                  selected={getSafeDateValue(value)}
                  shouldCloseOnSelect={false}
                />
              </div>
            </div>
          </div>
        );

      case 'Time_picker':
        return (
          <div className="icon-container w-150px">
            <DatePicker
              selected={getSafeDateValue(value)}
              popperPlacement="bottom-end"
              name="selectedDate"
              showTimeSelect
              timeIntervals={5}
              timeCaption="Time"
              timeFormat="HH:mm"
              dateFormat="HH:mm"
              showTimeSelectOnly
              onChange={(date) => onChange(date)}
              disabled={disableCondition}
              autoComplete="off"
            />
            <span className="icon-clock" />
          </div>
        );

      case 'Textbox':
        return (
          <>
            <input
              type="text"
              value={value || ''}
              onChange={(e) => onChange(e.target.value)}
              className="form-control text-bordered w-100 m-w-150"
              disabled={disableCondition}
              maxLength={characterLimit}
            />
            <div className="text-count">
              {value?.length || 0}/{characterLimit}
            </div>
          </>
        );

      case 'Text_area':
        return (
          <textarea
            type="Text area"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className="form-control text-bordered w-100 m-w-150"
            disabled={disableCondition}
          />
        );

      case 'Number':
        return (
          <input
            type="text"
            value={value || ''}
            className="form-control text-bordered w-120px"
            onKeyDown={(e) => {
              if ((e?.keyCode === 190 || e?.keyCode === 110) && subType === 'integer') {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              if (checkIsNumber(e.target.value)) {
                onChange(e.target.value);
              }
            }}
            disabled={disableCondition}
          />
        );

      case 'Number_percentage':
        return (
          <div className="d-flex align-items-center w-150px">
            <input
              type="number"
              value={value || ''}
              className="form-control text-bordered w-120px mr-1"
              onChange={(e) => {
                if (checkIsNumber(e.target.value)) onChange(e.target.value);
              }}
              disabled={disableCondition}
            />
            %
          </div>
        );
      case 'Status':
        return (
          <div className="align-items-center flex-wrap w-150px">
            <Select
              options={statusColoursOptions}
              value={value || activeStatus}
              inputProps={{
                autoComplete: 'off',
                autoCorrect: 'off',
                spellCheck: 'off',
              }}
              getOptionLabel={(option) => `${option.colourName}`}
              getOptionValue={(option) => `${option._id}`}
              className="common-select"
              classNamePrefix="common-select"
              styles={selectStyle}
              onChange={(e) => onChange(e)}
              isDisabled={disableCondition}
            />
          </div>
        );
      case 'HTML':
        return (
          <div className="w-200px">
            {value && value?.length > 0 ? (
              <OverlayTrigger
                placement="bottom"
                trigger="hover"
                rootClose
                overlay={
                  <Popover className="custom-popover">
                    <Popover.Content>
                      <p dangerouslySetInnerHTML={createMarkup(value || '')} />
                    </Popover.Content>
                  </Popover>
                }
              >
                <div className="d-flex align-items-center">
                  <div className="paragraph-ellipsis" dangerouslySetInnerHTML={createMarkup(value || '')} />
                  <button
                    className="btn-tbl-action btn"
                    type="button"
                    onClick={() => setState((prev) => ({ ...prev, activeHtmlEditor: true }))}
                    aria-label="edit"
                    disabled={disableCondition}
                  >
                    <span className="icon-Edit-1 f-24" />
                  </button>
                </div>
              </OverlayTrigger>
            ) : (
              <button
                className="btn-tbl-action btn"
                type="button"
                onClick={() => setState((prev) => ({ ...prev, activeHtmlEditor: true }))}
                aria-label="edit"
                disabled={disableCondition}
              >
                <span className="icon-Edit-1 f-24" />
              </button>
            )}
          </div>
        );

      case 'Multi_select_Dropdown': {
        const displayValue =
          columnType === 'manual' && (!value || value.length === 0)
            ? multipleDropdonwOptions?.filter((element) => {
                return options?.find((opt) => opt?.name === element?.value && opt?.isDefault);
              })
            : multipleDropdonwOptions?.filter((element) => {
                return value?.includes(element?.value);
              });

        return (
          <div className="w-100 m-w-150">
            <MultiSelect
              name="users"
              options={multipleDropdonwOptions}
              className="custom-multiselect"
              value={displayValue}
              onChange={(selected) => onChange(selected.map((val) => val.value))}
              labelledBy={t('RANGE_PLANS.PRODUCT_LIST.RENDER_HTML_COMPONENET.HTML_EDITOR.SELECT_USER')}
              disabled={disableCondition}
            />
          </div>
        );
      }

      case 'Label':
        return (
          <div className="color-list">
            {labelColours?.map((colou, ind) => {
              return (
                <div key={ind}>
                  <span
                    style={{
                      height: '15px',
                      width: '15px',
                      backgroundColor: colou?.colourHexCode,
                      borderRadius: '50%',
                      display: 'inline-block',
                    }}
                  />
                  <label className="m-0 ml-2">{colou?.colourName}</label>
                </div>
              );
            })}{' '}
          </div>
        );

      default:
        return null;
    }
  };

  const fieldId = useId();

  return (
    <>
      {renderComponentByType()}
      {activeHtmlEditor ? <HtmlEditorModal toggle={toggle} value={value || ''} handleChange={onChange} /> : null}
    </>
  );
}

export default RenderHtmlComponent;

const ExampleCustomInput = forwardRef(({ value, onClick, placeholder }, ref) => (
  <>
    <input type="text" value={value} disabled className="f-14" autoComplete="off" placeholder={placeholder} />{' '}
    <button type="button" className="btn-calender" onClick={onClick} ref={ref}>
      <i className="icon-calendar" style={{ top: 0 }} />
    </button>
  </>
));
